import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/en.json';
import ar from './locales/ar/ar.json';

const USE_CDN = true;
const CDN_BASE = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css';
const LOCAL_BASE = ''; 

const savedLang = localStorage.getItem('appLanguage') || 'en';

function setDirectionAndBootstrap(lng) {
  document.documentElement.lang = lng;
  const dir = (typeof i18n.dir === 'function') ? i18n.dir(lng) : (lng === 'ar' ? 'rtl' : 'ltr');
  document.documentElement.dir = dir;

  const id = 'bootstrap-css';
  let link = document.getElementById(id);
  if (!link) {
    link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }

  const file = lng === 'ar' ? 'bootstrap.rtl.min.css' : 'bootstrap.min.css';
  link.href = USE_CDN ? `${CDN_BASE}/${file}` : `/${LOCAL_BASE}${file}`;
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  })
  .then(() => {
    setDirectionAndBootstrap(i18n.language || savedLang);
  });

i18n.on('languageChanged', (lng) => {
  setDirectionAndBootstrap(lng);
  localStorage.setItem('appLanguage', lng);
});

export default i18n;
